<template>
  <b-container>
    <b-row>
      <b-col cols="6">
        <b-card>
          <b-form v-on:submit.prevent>
            <b-row>
              <b-col cols="12" class="text-left mb-2">
                <b-badge :variant="statusVariant(form.status)">
                  <span class="text-nowrap" v-if="form.status === 1">{{
                    form.status_name
                  }}</span>
                  <span class="text-nowrap" v-else-if="form.status === 2">{{
                    form.status_name
                  }}</span>
                  <span class="text-nowrap" v-else-if="form.status === 3">{{
                    form.status_name
                  }}</span>
                  <span class="text-nowrap" v-else-if="form.status === 4">{{
                    form.status_name
                  }}</span>
                  <span class="text-nowrap" v-else-if="form.status === 5">{{
                    form.status_name
                  }}</span>
                </b-badge>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col cols="4"> Code </b-col>
                  <b-col
                    cols="8"
                    class="text-right font-weight-bolder"
                    v-if="form.code === ''"
                  >
                    -
                  </b-col>
                  <b-col cols="8" class="text-right font-weight-bolder" v-else>
                    {{ form.code }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Order Code </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ form.order_code }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Assign by </b-col>
                  <b-col
                    md="8"
                    class="text-right font-weight-bolder"
                    v-if="form.assign_name === ''"
                  >
                    -
                  </b-col>
                  <b-col md="8" class="text-right font-weight-bolder" v-else>
                    {{ form.assign_name }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Shipping by </b-col>
                  <b-col
                    md="8"
                    class="text-right font-weight-bolder"
                    v-if="form.shipping_name === ''"
                  >
                    -
                  </b-col>
                  <b-col md="8" class="text-right font-weight-bolder" v-else>
                    {{ form.shipping_name }}
                  </b-col>
                </b-row>
                <hr v-if="form.status === 4" />
                <b-row v-if="form.status === 4">
                  <b-col md="4"> Reject Reason </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ form.reject_reason }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Datetime </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ moment(form.created_at) }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card>
          <b-form v-on:submit.prevent>
            <b-row>
              <b-col md="12">
                <label
                  for="history"
                  class="text-primary font-weight-bolder mb-1"
                  >Shipping Address</label
                >
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col md="3">
                    Name <span class="float-right">:</span>
                  </b-col>
                  <b-col md="9" class="font-weight-bolder">
                    {{ address.name }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="3">
                    Phone <span class="float-right">:</span>
                  </b-col>
                  <b-col md="9" class="font-weight-bolder">
                    {{ address.phone }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="3">
                    Address <span class="float-right">:</span>
                  </b-col>
                  <b-col md="9" class="font-weight-bolder">
                    {{ address.address }}, {{ address.city }},
                    {{ address.village }}, {{ address.district }},
                    {{ address.province }}, {{ address.country }},
                    {{ address.postal_code }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
        <b-card>
          <b-form v-on:submit.prevent>
            <b-row>
              <b-col md="12">
                <label
                  for="history"
                  class="text-primary font-weight-bolder mb-1"
                  >Customer Address</label
                >
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col md="3">
                    Name <span class="float-right">:</span>
                  </b-col>
                  <b-col md="9" class="font-weight-bolder">
                    {{ customer.name }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="3">
                    Email <span class="float-right">:</span>
                  </b-col>
                  <b-col md="9" class="font-weight-bolder">
                    {{ customer.email }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="3">
                    Business Phone <span class="float-right">:</span>
                  </b-col>
                  <b-col md="9" class="font-weight-bolder">
                    {{ customer.business_phone }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="3">
                    Address <span class="float-right">:</span>
                  </b-col>
                  <b-col md="9" class="font-weight-bolder">
                    {{ customer.address }}, {{ customer.city }},
                    {{ customer.village }}, {{ customer.district }},
                    {{ customer.province }}, {{ customer.country }},
                    {{ customer.postal_code }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="12"
        v-if="
          permissions.includes('warehouse-shipping-assign') && form.status === 1
        "
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mr-1"
          block
          v-b-modal.modal-assign
        >
          Assign
        </b-button>
      </b-col>
      <!-- modal Assign -->
      <b-modal
        id="modal-assign"
        title="Assign Form"
        ok-title="Assign"
        cancel-variant="outline-secondary"
        hide-footer
        no-close-on-backdrop
      >
        <validation-observer ref="loginValidation">
          <b-form ref="form" @submit.prevent>
            <b-form-group
              :state="errors"
              label="Assign"
              label-for="assign"
              invalid-feedback="Assign required"
            >
              <validation-provider
                #default="{ errors }"
                name="assign"
                rules="required"
              >
                <v-select
                  id="assign"
                  name="assign"
                  v-model="form.selectedEmployee"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="text"
                  :options="form.optionsEmployee"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Select Assign"
                  required="required"
                />
                <small class="text-danger">{{ errors[0] || errMessage }}</small>
              </validation-provider>
            </b-form-group>

            <b-row>
              <b-col>
                <b-button
                  class="mt-3"
                  type="submit"
                  variant="primary"
                  block
                  @click="assign()"
                >
                  Process
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <!-- end modal assign -->
    </b-row>
  </b-container>
</template>

<script>
import {
  BImg,
  BContainer,
  BBadge,
  BFormTextarea,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import { $themeConfig } from "@themeConfig";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
  components: {
    ToastificationContent,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BImg,
    BContainer,
    BBadge,
    BFormTextarea,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        status: null,
        status_name: "",
        code: "",
        order_code: "",
        assign_name: "",
        shipping_name: "",
        reject_reason: "",
        datetime: null,
        selectedEmployee: null,
        optionsEmployee: [],
        employeeValue: null,
      },
      address: {
        name: "",
        phone: null,
        address: "",
        city: "",
        village: "",
        district: "",
        province: "",
        country: "",
        postal_code: null,
      },
      customer: {
        name: "",
        email: "",
        business_phone: null,
        address: "",
        city: "",
        village: "",
        district: "",
        province: "",
        country: "",
        postal_code: null,
      },
      employee_id: null,
      items: [],
      permissions: [],
      errors: "",
      errMessage: "",
    };
  },
  watch: {
    "form.selectedEmployee": function (data) {
      this.form.employeeValue = data.value;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-warning",
        2: "light-info",
        3: "light-primary",
        4: "light-danger",
        5: "light-success",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    this.getAllPermissions();
    this.getEmployeeID();
    this.getDetails();
    this.getEmployees();
  },
  methods: {
    moment(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm");
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getEmployeeID() {
      this.employee_id = sessionStorage.getItem("employeeID");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("warehouse/shipping/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.status = response.data.data.status;
        this.form.status_name = response.data.data.status_name;
        this.form.code = response.data.data.code;
        this.form.order_code = response.data.data.order.code;
        this.form.assign_name = response.data.data.assign_by_name;
        this.form.shipping_name = response.data.data.shipping_by_name;
        this.form.reject_reason = response.data.data.reject_reason;
        this.form.datetime = response.data.data.created_at;

        this.address.name = response.data.data.address.name;
        this.address.phone = response.data.data.address.phone;
        this.address.address = response.data.data.address.address;
        this.address.city = response.data.data.address.city;
        this.address.village = response.data.data.address.village;
        this.address.district = response.data.data.address.district;
        this.address.province = response.data.data.address.province;
        this.address.country = response.data.data.address.country;
        this.address.postal_code = response.data.data.address.postal_code;

        this.customer.name = response.data.data.customer.name;
        this.customer.email = response.data.data.customer.email;
        this.customer.business_phone =
          response.data.data.customer.business_phone;
        this.customer.address = response.data.data.customer.address;
        this.customer.city = response.data.data.customer.city;
        this.customer.village = response.data.data.customer.village;
        this.customer.district = response.data.data.customer.district;
        this.customer.province = response.data.data.customer.province;
        this.customer.country = response.data.data.customer.country;
        this.customer.postal_code = response.data.data.customer.postal_code;
      });
    },
    getEmployees() {
      this.$http
        .get("employees?manager_id=" + this.employee_id)
        .then((response) => {
          // console.log(response.data.data)
          var datas = response.data.data;
          var i;
          for (i = 0; i < datas.length; i++) {
            var $data = {
              value: datas[i].id,
              text: datas[i].name,
            };
            // console.log($data)
            this.form.optionsEmployee.push($data);
          }
        });
    },
    assign() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/shipping/" + id + "/assign", {
          user_id: this.form.employeeValue,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success Assign",
              variant: "success",
            },
          });
          location.href = "/warehouse/shipping";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>